exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100vh;\n}\n\n.main-aside {\n    width: 20%;\n    min-width: 200px;\n    /*background: #211E1E;*/\n}\n\n.main-content {\n    width: 80%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n\n#logo {\n    margin: 20px;\n}\n\n.provider {\n    margin: 10px 0;\n    border: 1px solid #ddd;\n    padding: 10px;\n    max-width: 300px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/account/account.component.css
// module id = ../../../../../src/app/account/account.component.css
// module chunks = main